import MobileBanner from './MobileBanner';

export default MobileBanner;
